/* ===========================================================================
   EXPERTISE AGENCE — LUEUR DIFFUSE DANS LE MONOGRAMME
   ---------------------------------------------------------------------------
   Un spot primaire très diffus vit DANS les formes du monogramme fantôme :
   il suit le curseur avec du retard (la lumière traîne, elle ne colle pas),
   respire sur un champ de volutes (bruit domain-warpé qui déforme aussi le
   contour du spot — pas de bord, de la matière), et SE RÉVÈLE PAR LE BAS :
   un front lumineux au bord ondulant monte avec le scroll, la lumière
   envahit les jambages depuis le bas et se pose aux deux tiers de la
   traversée. Sans curseur (tactile, repos), le spot dérive lentement de
   lui-même : l'effet vit aussi au doigt, où le reveal au scroll est
   l'essentiel.

   WebGL brut, sur le modèle de mm_footer_shader.js : un quad, un fragment,
   zéro lib. Le canvas est découpé par la forme en CSS (mask-image sur le
   canvas, le même SVG que les couches d'entrée) : le shader n'a pas à
   connaître le monogramme, il peint une lumière — le masque fait le reste.

   REPLI : les deux couches CSS d'entrée (halo + nappe au scroll, dans
   mm-expertise-agence.css) restent le rendu sans JS. Quand le shader monte,
   il pose .is-shader sur le conteneur : la nappe CSS s'efface (le canvas la
   remplace), le halo débordant reste — c'est la profondeur derrière la
   forme, le shader n'éclaire que dedans.

   prefers-reduced-motion : on ne monte rien — pas de boucle, pas
   d'écouteur ; les couches CSS posées à leur état final font l'affaire.
   =========================================================================== */

(function () {
	'use strict';

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	var mono = document.querySelector('.mm-expa-mono');
	if (!mono) return;
	/* L'éditeur de thème réexécute les scripts d'une section rechargée : sans
	   ce garde-fou on empile les canvas et les boucles rAF. */
	if (mono.querySelector('canvas')) return;

	var carte = mono.closest('.mm-expa-carte') || mono;

	/* ─── Paramètres ──────────────────────────────────────────────────────── */
	var P = {
		beam: [0.898, 0.969, 0.490],  /* --primary #E5F77D */
		/* LA SOURCE EST LE BAS. Plus de spot flottant : une émission franche
		   au ras du bas qui s'épuise en montant, et sous le curseur une
		   COLONNE de lumière qui grimpe jusqu'à lui — la lumière diffuse
		   d'en bas, elle ne se promène pas. */
		srcGain: 1.05,     /* intensité de la source au ras du bas */
		srcK: 3.1,         /* essoufflement de la source (haut = meurt vite) */
		plumeGain: 0.95,   /* intensité de la colonne sous le curseur */
		plumeW: 0.26,      /* largeur de la colonne (fraction de la largeur) */
		plumeK: 1.9,       /* essoufflement de la colonne vers sa cime */
		lerp: 0.045,       /* retard de la colonne sur le curseur */
		revealLerp: 0.05,  /* retard du reveal sur le scroll — la lumière se pose */
		driftX: 0.62,      /* dérive au repos (fractions du cadre) */
		driftY: 0.55,
		wave: 0.30,        /* ondulation du front qui monte (fraction de hauteur) */
		front: 0.38,       /* douceur du front — large : il fond, il ne coupe pas */
		grain: 0.05,       /* gain du grain — contre le banding, côté matière */
		alphaMax: 0.95
	};

	var canvas = document.createElement('canvas');
	canvas.className = 'mm-expa-shader-canvas';
	mono.appendChild(canvas);

	var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false })
		|| canvas.getContext('experimental-webgl', { alpha: true, premultipliedAlpha: true, antialias: false });
	if (!gl) { canvas.remove(); return; }

	mono.classList.add('is-shader');

	var VERT = [
		'attribute vec2 p;',
		'void main(){ gl_Position = vec4(p, 0.0, 1.0); }'
	].join('\n');

	var FRAG = [
		'precision mediump float;',
		'uniform vec2 u_res;',
		'uniform vec2 u_mouse;',
		'uniform float u_reveal;',
		'uniform float u_time;',
		'',
		'float hash(vec2 p){ p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }',
		'float noise(vec2 p){',
		'  vec2 i = floor(p), f = fract(p);',
		'  f = f * f * (3.0 - 2.0 * f);',
		'  float a = hash(i), b = hash(i + vec2(1.0, 0.0));',
		'  float c = hash(i + vec2(0.0, 1.0)), d = hash(i + vec2(1.0, 1.0));',
		'  return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);',
		'}',
		'float fbm(vec2 p){',
		'  return noise(p) * 0.5 + noise(p * 2.1) * 0.3 + noise(p * 4.3) * 0.2;',
		'}',
		'',
		'void main(){',
		'  vec2 uv = gl_FragCoord.xy / u_res;',
		'',
		'  /* CHAMP ORGANIQUE : le bruit est lui-meme deplace par du bruit',
		'     (domain warp) — plus de nappes rondes, des volutes. Il derive',
		'     lentement et suit un peu le spot. */',
		'  vec2 flow = (u_mouse / u_res) * 0.30;',
		'  vec2 q = uv * 2.1 + vec2(u_time * 0.018, -u_time * 0.013) + flow;',
		'  vec2 warp = vec2(fbm(q + vec2(3.7, 1.2)), fbm(q + vec2(8.1, 5.9))) - 0.5;',
		'  float n = fbm(q + warp * 0.9);',
		'',
		'  /* LA SOURCE : le bas emet, la lumiere s essouffle en montant. Les',
		'     volutes la dechiquettent — des langues, pas un degrade. */',
		'  float src = exp(-uv.y * ' + P.srcK.toFixed(2) + ') * ' + P.srcGain.toFixed(2) + ';',
		'',
		'  /* LA COLONNE : sous le curseur, la source s etire et grimpe vers',
		'     lui — la lumiere est aspiree, elle ne se teleporte pas. La cime',
		'     est la hauteur du curseur ; au-dessus, elle fond vite. */',
		'  vec2 m = u_mouse / u_res;',
		'  float gx = exp(-pow((uv.x - m.x) / ' + P.plumeW.toFixed(2) + ', 2.0));',
		'  float cime = max(m.y, 0.18) + 0.10;',
		'  float plume = gx * exp(-max(uv.y / cime, 0.0) * ' + P.plumeK.toFixed(2) + ')',
		'              * smoothstep(cime + 0.28, cime - 0.05, uv.y)',
		'              * ' + P.plumeGain.toFixed(2) + ';',
		'',
		'  float glow = src + plume;',
		'  float bed = 0.0;',
		'',
		'  /* LE POP DU BAS : un front lumineux monte avec le scroll. Son bord',
		'     ondule sur les volutes et fond sur une grande hauteur — la lumiere',
		'     envahit les jambages depuis le bas, elle n apparait pas partout. */',
		'  float front = mix(-' + P.front.toFixed(2) + ', 1.0 + ' + P.wave.toFixed(2) + ' + ' + P.front.toFixed(2) + ', u_reveal);',
		'  front += (fbm(vec2(uv.x * 2.6 + u_time * 0.05, u_time * 0.02)) - 0.5) * ' + P.wave.toFixed(2) + ';',
		'  float rise = smoothstep(front, front - ' + P.front.toFixed(2) + ', uv.y);',
		'',
		'  float nap = mix(0.45, 1.42, n);',
		'  float a = (glow + bed) * nap * rise * smoothstep(0.0, 0.25, u_reveal);',
		'  /* Grain anime, proportionnel : de la matiere, pas du bruit de fond. */',
		'  a += (hash(gl_FragCoord.xy + fract(u_time) * vec2(17.0, 29.0)) - 0.5) * ' + P.grain.toFixed(2) + ' * a;',
		'  a = clamp(a, 0.0, ' + P.alphaMax.toFixed(2) + ');',
		'  vec3 col = vec3(' + P.beam[0] + ', ' + P.beam[1] + ', ' + P.beam[2] + ');',
		'  gl_FragColor = vec4(col * a, a);   /* alpha premultiplie */',
		'}'
	].join('\n');

	function compile(type, src) {
		var sh = gl.createShader(type);
		gl.shaderSource(sh, src);
		gl.compileShader(sh);
		if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) return null;
		return sh;
	}
	var vs = compile(gl.VERTEX_SHADER, VERT);
	var fs = compile(gl.FRAGMENT_SHADER, FRAG);
	if (!vs || !fs) { canvas.remove(); mono.classList.remove('is-shader'); return; }
	var prog = gl.createProgram();
	gl.attachShader(prog, vs);
	gl.attachShader(prog, fs);
	gl.linkProgram(prog);
	if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.remove(); mono.classList.remove('is-shader'); return; }
	gl.useProgram(prog);

	var buf = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, buf);
	gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
	var loc = gl.getAttribLocation(prog, 'p');
	gl.enableVertexAttribArray(loc);
	gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

	var U = {
		res: gl.getUniformLocation(prog, 'u_res'),
		mouse: gl.getUniformLocation(prog, 'u_mouse'),
		reveal: gl.getUniformLocation(prog, 'u_reveal'),
		time: gl.getUniformLocation(prog, 'u_time')
	};
	gl.clearColor(0, 0, 0, 0);

	/* ─── Taille — la discipline du footer : réallocations espacées ───────── */
	var w = 0, h = 0;
	var lastAlloc = 0, settleTimer = null;
	function resize(force) {
		var cw = mono.offsetWidth, ch = mono.offsetHeight;
		if (!cw || !ch) return false;
		var dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 768 ? 1 : 1.5);
		var nw = Math.round(cw * dpr), nh = Math.round(ch * dpr);
		if (nw === w && nh === h) return false;
		var now = performance.now();
		if (!force && now - lastAlloc < 160) {
			clearTimeout(settleTimer);
			settleTimer = setTimeout(function () { resize(true); }, 180);
			return false;
		}
		lastAlloc = now;
		w = nw; h = nh;
		canvas.width = w; canvas.height = h;
		gl.viewport(0, 0, w, h);
		gl.uniform2f(U.res, w, h);
		return true;
	}

	/* ─── Curseur — cible réelle ou dérive de repos ───────────────────────── */
	var hasPointer = false;
	var tx = 0, ty = 0;      /* cible, en px canvas (origine en bas à gauche) */
	var mx = -1e4, my = -1e4; /* position lissée — démarre hors champ */

	function pointerTarget(event) {
		var r = canvas.getBoundingClientRect();
		if (!r.width) return;
		var dpr = w / r.width;
		tx = (event.clientX - r.left) * dpr;
		ty = h - (event.clientY - r.top) * dpr;   /* y GL vers le haut */
		hasPointer = true;
	}
	carte.addEventListener('pointermove', pointerTarget);
	carte.addEventListener('pointerleave', function () { hasPointer = false; });

	function idleTarget(t) {
		/* Une dérive lente en huit, dans le tiers droit de la forme —
		   là où vivent les jambages du monogramme. */
		tx = (P.driftX + 0.22 * Math.sin(t * 0.00023)) * w;
		ty = (P.driftY + 0.20 * Math.sin(t * 0.00031 + 1.7)) * h;
	}

	/* ─── Reveal au scroll ────────────────────────────────────────────────── */
	function revealAmount() {
		var r = mono.getBoundingClientRect();
		var vh = window.innerHeight;
		/* Éteint quand le haut de la forme franchit le bas de l'écran, posé
		   quand il atteint le tiers supérieur — la course de la nappe CSS. */
		var p = (vh * 0.95 - r.top) / (vh * 0.65);
		if (p < 0) p = 0;
		else if (p > 1) p = 1;
		return p * p * (3 - 2 * p);   /* smoothstep : arrivée posée */
	}

	/* ─── Boucle — seulement quand la forme est à l'écran ─────────────────── */
	var visible = false;
	var rafId = null;
	var start = 0;
	/* Le reveal est LISSÉ : revealAmount() donne la cible au fil du scroll,
	   la valeur envoyée au shader la rejoint à ~5 % par frame — un coup de
	   molette rapide n'allume plus la forme d'un bloc, la lumière monte du
	   bas et se pose (~1s), dans l'esprit de la traîne du curseur. */
	var reveal = 0;

	function frame(now) {
		if (!visible) { rafId = null; return; }
		if (!start) start = now;
		resize();
		if (!hasPointer) idleTarget(now);
		if (mx < -9e3) { mx = tx; my = ty; }   /* première frame : pas de traversée */
		mx += (tx - mx) * P.lerp;
		my += (ty - my) * P.lerp;
		gl.uniform2f(U.mouse, mx, my);
		reveal += (revealAmount() - reveal) * P.revealLerp;
		gl.uniform1f(U.reveal, reveal);
		gl.uniform1f(U.time, (now - start) / 1000);
		gl.clear(gl.COLOR_BUFFER_BIT);
		gl.drawArrays(gl.TRIANGLES, 0, 3);
		rafId = requestAnimationFrame(frame);
	}

	var io = new IntersectionObserver(function (entries) {
		visible = entries.some(function (e) { return e.isIntersecting; });
		if (visible && rafId === null) rafId = requestAnimationFrame(frame);
	}, { rootMargin: '10% 0px' });
	io.observe(mono);
})();
